import '@/user/common';
import '@/shared/calendar';
import { sliderSetting, setColorClass } from '@/shared/calendar';

// カレンダーのカルーセル
sliderSetting(true, false);

// 日程をクリア
const cancelBtn = document.getElementById('calendar_cancel');
cancelBtn.addEventListener('click', e => {
    e.preventDefault();
    // checked を外す
    const checkedInputs = document.querySelectorAll('#search_from input[type=checkbox]:checked');
    checkedInputs.forEach(checkedInput => {
        checkedInput.checked = false;
    });
    // カレンダーの色調整
    setColorClass();
})

// 同日開催のフェアをもっと見る
const moreBtn = document.getElementsByClassName('js-more_btn');
Array.from(moreBtn).map((btn) => {
    btn.addEventListener('click', e => {
        const parent = e.currentTarget.parentNode;
        parent.classList.add('is-open');
    });
});

// ソート条件変更
const sortSelect = document.getElementById('js-sort_select');
if (sortSelect) {
    const fairChecked = 1;
    const dataChecked = 0;
    const fairParam = 'group_by=id';
    const currentUrl = new URL(window.location.href);
    const currentParams = currentUrl.searchParams;
    const searchParams = new URLSearchParams(currentUrl.search);

    sortSelect.selectedIndex = dataChecked;
    // クエリパラメータがついているときはフェア順にチェック
    if (searchParams.has('group_by')) {
        sortSelect.selectedIndex = fairChecked;
    }

    // 選択された条件でリダイレクト
    sortSelect.addEventListener('change', (e) => {
        const sortData = e.currentTarget.value;
        const hasFairType = Array.from(searchParams.keys()).some(key => key.startsWith('fair_type['));
        const hasDate = Array.from(searchParams.keys()).some(key => key.startsWith('date['));
        const pathname = currentUrl.pathname;
        // ページャーのURLパスを削除
        const firstPagePath = pathname.replace('page2/', '');

        switch (true){
            // 絞り込みクエリパラメータなし+表示切り替えが日付
            case sortData === 'date' && !hasFairType && !hasDate:
                window.location.href = `${currentUrl.origin}${firstPagePath}`;
                break;
            // 絞り込みクエリパラメータなし＋表示切り替えがフェア
            case sortData === 'fair' && !hasFairType && !hasDate:
                // ページャーパラメータの削除
                currentParams.delete('page');
                window.location.href = `${currentUrl.href}?${fairParam}`;
                break;
            // 絞り込みクエリパラメータあり＋表示切り替えが日付
            case sortData === 'date' && (hasFairType || hasDate):
                // フェア順パラメータの削除
                currentParams.delete('group_by');
                window.location.href = `${currentUrl.origin}${firstPagePath}${currentUrl.search}`;
                break;
            // 絞り込みクエリパラメータあり＋表示切り替えがフェア
            case sortData === 'fair' && (hasFairType || hasDate):
                // ページャーパラメータの削除
                currentParams.delete('page');
                window.location.href = `${currentUrl.href}&${fairParam}`;
                break;
            default:
                window.location.href = `${currentUrl.origin}${firstPagePath}`;
                break;
        }
    });
}
